"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Price_1 = require("../../../../../../common/components/prices/price/Price");
var priceWithLabelStyles_1 = require("./priceWithLabelStyles");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var PriceWithLabel = function (_a) {
    var dataTest = _a.dataTest, price = _a.price, currency = _a.currency, label = _a.label, priceDisplayType = _a.priceDisplayType, labelBefore = _a.labelBefore, taxLabel = _a.taxLabel;
    var style = priceWithLabelStyles_1.default();
    var showAdditionalPriceLabel = core_1.useTheme().checkoutLite.summary.showAdditionalPriceLabel;
    return (<core_1.Box display="flex" flexDirection="column" justifyContent={'center'} alignItems={'center'}>
      <core_1.Box display="flex" alignItems="center" justifyContent="center">
        {labelBefore}
        <Price_1.default price={price} priceDisplayType={priceDisplayType} currency={currency} className={style.priceElement} dataTest={"" + dataTest} taxLabel={taxLabel} variant={'body1'}/>
        {showAdditionalPriceLabel && (<core_1.Typography className={style.additionalPriceLabel} component={'span'} data-test={'text:additionalPriceLabel'}>
            &nbsp;
            <Translation_1.default id={'trans__configurator__price_display__additional_label'}/>
          </core_1.Typography>)}
      </core_1.Box>
      {label && (<core_1.Typography variant="caption" className={style.label} data-test={'text:price:label'}>
          {label}
        </core_1.Typography>)}
    </core_1.Box>);
};
exports.default = PriceWithLabel;
